<script>
    export default {
        methods: {
            async downloadPDF(file, base64) {
                const blob = await (await fetch(`data:application/pdf;base64,${base64}`)).blob();
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = file;
                link.click();
            },
        }
    }
</script>